import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { formatKmString } from "../../helpers/formatKmString";
import { getContractServicesDisplayName } from "../../data/contract";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";
import { BrandType as Brand } from "@bus/models";

export const AddicionalFinancialInformation = () => {
    const { t } = useTranslation(["summarypage"]);
    const { goToQuestionsStep, submitAnswersRequest } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                titleLevel={2}
                title={t("summarypage:addicional-financial-information.title", {
                    brand: capitalizeBrand(brand as Brand),
                })}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "AddicionalFinancialInformationSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToQuestionsStep(4, true);
                    },
                    tabIndex: 0,
                }}
                id="AddicionalFinancialInformationSummary"
            >
                {matchMakerAnswers && (
                    <DescriptionList grid>
                        <DescriptionList.Group termText={t("summarypage:addicional-financial-information.product")}>
                            <DescriptionList.Detail id="AddicionalFinancialInformationProduct">
                                {matchMakerAnswers.contractType && matchMakerAnswers.contractType.length > 0
                                    ? matchMakerAnswers.contractType?.map((x, index) => {
                                        if (index + 1 < (matchMakerAnswers.contractType?.length ?? 0))
                                            return x + ", ";
                                        return x;
                                    })
                                    : "-"}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group
                            termText={t("summarypage:addicional-financial-information.yearly-mileage")}
                        >
                            <DescriptionList.Detail id="AddicionalFinancialInformationYearlyMileage">
                                {matchMakerAnswers.kmsPerYear
                                    ? formatKmString(matchMakerAnswers.kmsPerYear) + " km"
                                    : "-"}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:addicional-financial-information.services")}>
                            <DescriptionList.Detail id="AddicionalFinancialInformationServices">
                                {matchMakerAnswers.services && matchMakerAnswers.services.length > 0
                                    ? matchMakerAnswers.services?.map((x, index) => {
                                        if (index + 1 < (matchMakerAnswers.services?.length ?? 0))
                                            return getContractServicesDisplayName(x, t) + ", ";
                                        return getContractServicesDisplayName(x, t);
                                    })
                                    : "-"}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                    </DescriptionList>
                )}
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
